<template>
  <div style="background-color: #f4f5fd">
    <b-row>
      <b-col cols="12">
        <b-tabs>
          <b-tab
            title="Active"
            :lazy="$store.state.activeEmployeeTabLazyLoad"
          >
            <ActiveEmployeeTable />
          </b-tab>
          <b-tab
            title="Terminated"
            :lazy="$store.state.terminatedEmployeeTabLazyLoad"
          >
            <TerminatedEmployeeTable />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import ActiveEmployeeTable from "../../components/employeeComponents/manageEmployeeComponents/activeEmployeeTable.vue";
import TerminatedEmployeeTable from "../../components/employeeComponents/manageEmployeeComponents/terminatedEmployeeTable.vue";
export default {
  name: "ManageEmployee",
  components: {
    ActiveEmployeeTable,
    TerminatedEmployeeTable,
  },
  data () {
    return {
      itemsBreadcrumb: [
        {
          text: "Dashboard",
          href: "dashboard",
        },
        {
          text: "Manage Employee",
          href: "#",
          active: true,
        },
      ],
    };
  },
  methods: {},
};
</script>
<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";
/* @import "../../assets/styles/theme1/card.css"; */
@import "../../assets/styles/theme1/badge.css";
</style>

<style>
.table-hover tbody tr:hover td {
  background-color: rgb(255, 251, 242) !important;
}
</style>